// extracted by mini-css-extract-plugin
export var swapPageTitle = "oNXi59WBMeFmRRvq65pQ";
export var swapSpinnerWrapper = "i_YHVhMVKYOOUVTlDbpF";